import { Stack, Text } from '@fluentui/react';

export const ErrorPage = () => {
    return (
        <Stack
            verticalAlign="center"
            horizontalAlign="center"
            styles={{ root: { height: '100vh' } }}
        >
            <Text variant="xxLarge">Something went wrong!</Text>
            <Text>Please try again later.</Text>
        </Stack>
    );
};

export default ErrorPage;
